import React from 'react';
import { cn } from '../../../infrastructure/lib/utils';

interface ChartCardProps {
  title: string;
  description?: string;
  className?: string;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
}

export function ChartCard({
  title,
  description,
  className,
  headerAction,
  children,
}: ChartCardProps) {
  return (
    <div className={cn("glass-panel p-6 rounded-3xl flex flex-col", className)}>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h4 className="font-display text-xl font-bold leading-none">{title}</h4>
          {description && (
            <p className="text-on-surface-variant text-sm mt-1">{description}</p>
          )}
        </div>
        {headerAction && <div>{headerAction}</div>}
      </div>

      <div className="flex-1 w-full min-h-[250px]">
        {children}
      </div>
    </div>
  );
}
